import { useEscapeById, useModal } from 'shared/lib/modal';
import { ModalCard } from '../../cards/modalCard';
import { Flex } from '../../flex';
import { Typography } from '../../typography';
import { ButtonsContainer, Circle, MarginBottom } from './styles';
import { Img } from '../../imgStyledComponent';
import marker from 'assets/icons/exclamation-mark.svg';
import { FC } from 'react';
import { ButtonOutlined } from 'shared/ui/buttons/buttonOutlined';

interface ModalNotificationProps {
	onClose?: () => void;
	title: string | null;
}

export const ModalNotification: FC<ModalNotificationProps> = ({
	onClose,
	title,
}) => {
	const { closeModal } = useModal();

	const close = () => {
		onClose?.();
		closeModal();
	};

	useEscapeById('notification-modal');

	return (
		<ModalCard styles={{ cardVariant: 'default' }} onClose={onClose} id="notification-modal">
			<MarginBottom>
				<Flex $justify="center">
					<Circle>
						<Img src={marker} $size="giant" />
					</Circle>
				</Flex>
			</MarginBottom>
			<MarginBottom>
				<Flex $justify="center">
					<Typography
						mode={'large'}
						isBold={true}
						textAlignCenter={true}
					>
						{title}
					</Typography>
				</Flex>
			</MarginBottom>
			<ButtonsContainer>
				<Flex $justify="center" $direction="column" $gap="15px">
					<ButtonOutlined onClick={close}>Закрыть</ButtonOutlined>
				</Flex>
			</ButtonsContainer>
		</ModalCard>
	);
};
